module.exports = __webpack_public_path__ + "img/inbestme-dark.1d8657dd.png";